import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { generateCodPayable, getCodPayableDetails, getCodPayableBySummaryId, getCodPayableExcel, addBankCharges, deleteBankCharges, editBankCharges, getAllBankCharges, getBanksLookup, getCodPayables, getPayableAmount, sendCodBulkEmail, getCodArchiveSummary, addAdjustmentEntry, exportCodArchiveSummary, sendCodEmailWithFile, uploadCodAttachment, deleteCodAttachment, uploadBankReceipt, downloadBankReceipt } from "../../services/CodAutomation/codAutomationServices";

const initialValues = {
  bankChargesList: [],
  banksLookupList: [],
};

let codAutomationStore = (set) => ({
  ...initialValues,
  getCodPayables: async (data) => {
    const response = await getCodPayables(data);
    return response;
  },
  getPayableAmount: async (customer, from, to, destinationCountry, signal) => {
    const response = await getPayableAmount(customer, from, to, destinationCountry, signal);
    return response;
  },
  generateCodPayable: async (data) => {
    const response = await generateCodPayable(data);
    return response;
  },
  sendCodBulkEmail: async (data) => {
    const response = await sendCodBulkEmail(data);
    return response;
  },
  getCodPayableDetails: async (customer, from, to, destinationCountry, size, cursor) => {
    const response = await getCodPayableDetails(customer, from, to, destinationCountry, size, cursor);
    return response;
  },
  getCodPayableBySummaryId: async (summaryId) => {
    const response = await getCodPayableBySummaryId(summaryId);
    return response;
  },
  getCodPayableExcel: async (summaryId) => {
    const response = await getCodPayableExcel(summaryId);
    return response;
  },
   saveAdjustmentEntry: async (payload) => {
    const response = await addAdjustmentEntry(payload);
    return response;
  },

  getAllBankCharges: async () => {
    const response = await getAllBankCharges();
    set({ bankChargesList: response?.data?.data || [] });
    return response;
  },
  getBanksLookup: async () => {
    const response = await getBanksLookup();
    set({ banksLookupList: response?.data?.data || [] });
    return response;
  },
  addBankCharges: async (data) => {
    const response = await addBankCharges(data);
    return response;
  },
  editBankCharges: async (id, data) => {
    const response = await editBankCharges(id, data);
    return response;
  },
  deleteBankCharges: async (id) => {
    const response = await deleteBankCharges(id);
    return response;
  },
  getCodArchiveSummary: async (data) => {
    const response = await getCodArchiveSummary(data);
    return response;
  },
  exportCodArchiveSummary: async (data) => {
    const response = await exportCodArchiveSummary(data);
    return response;
  },
  sendCodEmailWithFile: async (data, file) => {
    const response = await sendCodEmailWithFile(data, file);
    return response;
  },
  uploadCodAttachment: async (customerAccount, file) => {
    const response = await uploadCodAttachment(customerAccount, file);
    return response;
  },
  deleteCodAttachment: async (attachmentId) => {
    const response = await deleteCodAttachment(attachmentId);
    return response;
  },
  uploadBankReceipt: async (summaryId, customerAccount, file, sendEmail = false) => {
    const response = await uploadBankReceipt(summaryId, customerAccount, file, sendEmail);
    return response;
  },
  downloadBankReceipt: async (summaryId, customerAccount) => {
    const response = await downloadBankReceipt(summaryId, customerAccount);
    return response;
  },
});

codAutomationStore = devtools(codAutomationStore);

export const useCodAutomationStore = create(codAutomationStore);